import * as React from 'react';
import type { FieldValues, UseFormReturn } from 'react-hook-form';
import { USStates } from '@gcv/shared';

import { USStateOptions } from 'domain/consts';
import type { ResponseAddressData } from 'ui';
import { Container, ContainerItem, Form, Header, InputAddress, InputSelect, InputText, InputZip } from 'ui';

interface Props extends Record<string, unknown> {
  form: UseFormReturn<FieldValues>;
  isMobile: boolean;
  onChange: () => void;
}

export const UserHomeAddressForm: React.FC<Props> = ({ form, isMobile, onChange }) => {
  return (
    <Container padding="0" dataCy="home-address-card">
      <Container padding={isMobile ? '20px 0 8px 0' : '28px 0 8px 0'}>
        <Header mobileHeader={isMobile} content="Home Address" type="h2" />
      </Container>
      <Form>
        <Container padding="0" width="100%">
          <ContainerItem
            padding={isMobile ? '10px 0' : '10px 12px 10px 0'}
            width="100%"
            maxWidth={isMobile ? 'none' : '20%'}
            minWidth={isMobile ? 'none' : '300px'}
          >
            <InputAddress
              name="address"
              dataCy="street-address"
              label="Address"
              onChange={(selectedAddress: ResponseAddressData) => {
                form.setValue('city', selectedAddress.Place.Municipality);
                const state =
                  USStates[selectedAddress.Place.Region.replace(' ', '_') as keyof typeof USStates];
                form.setValue('state', state);
                form.setValue('zipcode', selectedAddress.Place.PostalCode);
                if (onChange) onChange();
              }}
              onBlur={() => {
                if (onChange) onChange();
              }}
              rules={{
                required: { message: 'is required', value: true }
              }}
              form={form}
              {...form}
            />
          </ContainerItem>
          <ContainerItem
            padding={isMobile ? '10px 0' : '10px 12px 10px 0'}
            width="100%"
            maxWidth={isMobile ? 'none' : '20%'}
            minWidth={isMobile ? 'none' : '200px'}
          >
            <InputText
              label="City"
              name="city"
              rules={{
                required: { message: 'is required', value: true },
                pattern: { message: 'must be valid', value: /^[a-zA-Z ]+$/ }
              }}
              dataCy="city"
              onChange={onChange}
              onBlur={onChange}
              {...form}
            />
          </ContainerItem>
          <ContainerItem
            padding={isMobile ? '10px 0' : '10px 12px 10px 0'}
            width="100%"
            maxWidth={isMobile ? 'none' : '20%'}
            minWidth={isMobile ? 'none' : '200px'}
          >
            <InputSelect
              label="State"
              name="state"
              options={USStateOptions}
              rules={{ required: { message: 'is required', value: true } }}
              dataCy="state"
              additionalOnChange={onChange}
              onBlur={onChange}
              {...form}
            />
          </ContainerItem>
          <ContainerItem
            padding={isMobile ? '10px 0' : '10px 12px 10px 0'}
            width="100%"
            maxWidth={isMobile ? 'none' : '20%'}
            minWidth={isMobile ? 'none' : '200px'}
          >
            <InputZip
              name="zipcode"
              label="Zip Code"
              rules={{
                required: { message: 'is required', value: true }
              }}
              dataCy="zip-code"
              onChange={onChange}
              onBlur={onChange}
              {...form}
            />
          </ContainerItem>
        </Container>
      </Form>
    </Container>
  );
};
